import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { VesselsService } from '@navstation-portal/vessels/data-access/service';
import { VesselsStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { vesselsEvents } from './vessels-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselsEffects<_>() {
  return signalStoreFeature(
    type<{ state: VesselsStoreState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const vesselsService = inject(VesselsService);
      return {
        fetchVessels$: events.on(vesselsEvents.fetchVessels).pipe(
          exhaustMap(({ payload: emailAddress }) =>
            vesselsService.getVessels(emailAddress).pipe(
              mapResponse({
                next: ({ data: vessels }) => vesselsEvents.fetchVesselsSuccess(vessels),
                error: (err: Error) => vesselsEvents.fetchVesselsFailed(err),
              })
            )
          )
        ),
      };
    })
  );
}
